import { Stack } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { CreateReportFormData } from '../../models/reports/input';
import { Purchase, useReportStore } from '../../providers';
import { CardBody } from '../Card';
import { NumberFormControl } from '../Form';
import { SwitchFormControl } from '../Form/SwitchFormControl/SwitchFormControl';
import { Section } from '../PropertyInformation';

export function PurchaseInformation() {
  const { setValue, watch } = useFormContext<CreateReportFormData>();
  const { purchase } = useReportStore();

  useEffect(() => {
    if (purchase) {
      Object.keys(purchase).forEach((key) =>
        setValue(key as keyof Purchase, purchase[key as keyof Purchase])
      );
    }
  }, [setValue, purchase]);

  return (
    <Section>
      <CardBody>
        <div className="flex flex-row gap-x-4">
          <Stack className="basis-1/3">
            <NumberFormControl
              name="purchasePrice"
              label="Purchase Price"
              type="price"
              defaultValue={0}
            />
          </Stack>
          <Stack className="basis-1/3">
            <NumberFormControl
              name="downPayment"
              label="Down Payment"
              type="percent"
              defaultValue={0}
            />
          </Stack>
          <Stack className="basis-1/3">
            <NumberFormControl
              name="interestRate"
              label="Interest Rate"
              type="percent"
              precision={2}
              defaultValue={0}
            />
          </Stack>
        </div>
        <div className="flex flex-row gap-x-4">
          <Stack className="basis-1/3">
            <NumberFormControl name="term" label="Term In Years" type="generic" defaultValue={30} />
          </Stack>
          <Stack className="basis-1/3">
            <NumberFormControl
              name="closingCosts"
              label="Closing Costs"
              type="price"
              defaultValue={0}
            />
          </Stack>
          <Stack className="basis-1/3">
            <NumberFormControl
              name="salesCommission"
              label="Sales Commission"
              type="percent"
              precision={2}
              defaultValue={0}
            />
          </Stack>
        </div>
        <div className="flex flex-row gap-x-4">
          <div className="mt-1">
            <SwitchFormControl
              name="isRehab"
              label="Is rehab?"
              formControlProps={{ alignItems: 'center' }}
              formLabelProps={{ mb: '0' }}
              defaultValue={false}
            />
          </div>
          {watch('isRehab') && (
            <>
              <Stack className="basis-1/3">
                <NumberFormControl
                  name="rehabCosts"
                  label="Rehab Costs"
                  type="price"
                  defaultValue={0}
                />
              </Stack>
              <Stack className="basis-1/3">
                <NumberFormControl
                  name="arv"
                  label="After Repair Value (ARV)"
                  type="price"
                  defaultValue={0}
                />
              </Stack>
            </>
          )}
        </div>
        <div className="flex flex-row gap-x-4">
          <Stack className="basis-1/4">
            <NumberFormControl name="taxes" label="Annual Taxes" type="price" defaultValue={0} />
          </Stack>
          <Stack className="basis-1/4">
            <NumberFormControl
              name="insurance"
              label="Annual Insurance"
              type="price"
              defaultValue={0}
            />
          </Stack>
          <Stack className="basis-1/4">
            <NumberFormControl name="pmi" label="Monthly PMI" type="price" defaultValue={0} />
          </Stack>
          <Stack className="basis-1/4">
            <NumberFormControl
              name="furnishings"
              label="Furnishings"
              type="price"
              defaultValue={0}
            />
          </Stack>
        </div>
      </CardBody>
    </Section>
  );
}

export default PurchaseInformation;
